import React from 'react';
import {
  Button as ChakraButton,
  ButtonGroup as ChakraButtonGroup,
  ChakraProvider
} from '@chakra-ui/react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import './styles/index.scss';
import classNames from 'classnames';

export type ButtonActionState = {
  visible: boolean;
  enabled: boolean;
};

export type ButtonActionStateMap = {
  [key: string]: ButtonActionState;
};

const DEFAULT_BUTTON_ACTION_STATE = {
  visible: true,
  enabled: true
};

type ButtonIconProps = {
  isAttached?: boolean;
  label: string;
  iconName: IconName;
  actionsState?: ButtonActionState;
} & React.HTMLAttributes<HTMLButtonElement>;

const ButtonIcon = (props: ButtonIconProps) => {
  const {
    isAttached,
    label,
    iconName,
    className,
    actionsState = DEFAULT_BUTTON_ACTION_STATE,
    ...spreadable
  } = props;

  if (!actionsState.visible) {
    // return an empty span - easier for ts to handle than
    // a false atm.
    return <span key={label} />;
  }
  const classes = classNames(className, 'icon-button', {
    'icon-disabled': !actionsState.enabled,
    'icon-enabled': actionsState.enabled,
    'icon-visible': actionsState.visible
  });
  const title = actionsState.enabled
    ? `${props.label}`
    : `Unable to ${props.label}`;
  return (
    <>
      {/* Icons have been added in the body of the button because when 
      using as left or right there is inherited padding that we can't remove. 
      And IconButtons have a hard coded zero padding that we don't want. */}
      <ChakraButton
        {...spreadable}
        //as="a"
        mr={isAttached ? '-px' : undefined}
        isDisabled={!actionsState.enabled}
        className={classes}
        aria-label={title}
        title={title}>
        <BiomeIcon iconName={iconName} />
      </ChakraButton>
    </>
  );
};

ButtonIcon.displayName = 'ButtonIcon';

export { ButtonIcon };
